import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductChangesReport } from "./components/ProductChangesReport";

export const ProductChangesReportPage = () => (
	<>
		<HelmetDexteel title="Product Changes Report" />
		<ProductChangesReport />
	</>
);
